/**
 * Tabela de vencimentos da ficha do equipamento (#363): uma linha por data que o tipo usa
 * (`dues.*` é `null` quando não usa). Os dias e a situação de cada data vêm do servidor
 * (`dues` e `situation.motivos`); o navegador só os escreve.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';

import { DataTable, type DataTableColumn } from '../../../components';
import { ValidityChip } from '../../../components/common/ValidityChip';
import type { FireEquipment, FireEquipmentLabels } from '../../../types/fireEquipment';
import { formatIsoDate } from '../fireDates';
import { dueRows, type DueRow } from './dueRows';

const COLUMNS: DataTableColumn<DueRow>[] = [
  {
    id: 'title',
    label: 'Vencimento',
    primary: true,
    render: (row) => (
      <Box>
        <Typography variant="body1" fontWeight="bold">
          {row.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {row.hint}
        </Typography>
      </Box>
    ),
  },
  { id: 'date', label: 'Data', render: (row) => formatIsoDate(row.date) },
  {
    id: 'situation',
    label: 'Situação',
    render: (row) => <ValidityChip situation={row.chip.situation} days={row.chip.days} label={row.chip.label} />,
  },
];

export interface DuesTableProps {
  equipment: FireEquipment;
  labels: Pick<FireEquipmentLabels, 'frequency' | 'situation'>;
}

export const DuesTable: React.FC<DuesTableProps> = ({ equipment, labels }) => (
  <DataTable
    embedded
    columns={COLUMNS}
    rows={dueRows(equipment, labels)}
    getRowId={(row) => row.field}
    emptyState={{ title: 'Sem vencimentos', description: 'Este tipo de equipamento não tem datas de vencimento.' }}
  />
);

export default DuesTable;
